import { Button } from '@chakra-ui/button';
import { useColorMode } from '@chakra-ui/color-mode';
import { Image } from '@chakra-ui/image';
import { Circle, Stack, Flex, Box, Text } from '@chakra-ui/layout';
import { useMediaQuery } from '@chakra-ui/media-query';
import React from 'react';

function Header() {

  const { colorMode } = useColorMode();
  const isDark = colorMode ==="dark";
  const [isNotSmallerScreen] = useMediaQuery("(min-width:600px)");

    return (
        <Stack>
            <Circle position="absolute" bg="blue.100" opacity="0.1"
                w="300px" h="300px" alignSelf="flex-end" />
            <Flex direction={isNotSmallerScreen ? "row" : "column"}
                spacing="200px" p={isNotSmallerScreen ? "32" : "0"}
                alignSelf="flex-start">
                <Box mt={isNotSmallerScreen ? "0" : 16} align='flex-start'>
                    <Text fontSize="5xl" fontWeight="semibold">Hello! I am</Text>
                    <Text fontSize="7xl" fontWeight="bold" bgGradient="linear(to-r, teal.400, red.500, purple.600)" bgClip='text' >Sudhanshu Sharma</Text> 
                    <Text color={isDark ? "gray.200" : "gray.500"}>UI/UX designer, Front-end Developer</Text>
          <Button mt={8} colorScheme="teal" onClick={() => window.open("https://www.linkedin.com/in/ss-ace")}>Contact me</Button>
          </Box>
          <Image alignSelf="center" mt={isNotSmallerScreen ? "0" : "12"}
                 mb={isNotSmallerScreen ? "0" : "12"} borderRadius='full'
                 backgroundColor="transparent" boxShadow="lg"
                 boxSize="300px" src="https://avatars.githubusercontent.com/u/77171248?v=4"/>
        
         </Flex>
      </Stack>
    );
  }
  
  export default Header;